<template>
  <div class="w-100">
    <div class="alert alert-info" role="alert" v-show="showMessage">
      Success Delete
    </div>
    <ModalConfirm 
      modalId="categoryModal" 
      :text="`Your change(s) will affect other Menu(s) that has dependency to Category Product. Please make sure other related Category Product Menu has been checked and reviewed.`" 
      @onClick="deleteCategory(id)"
      :center="true" :buttonConfig="{
          cancelText: 'CANCEL',
          confirmText: `CONFIRM`
        }" />
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:name="{data}">
        <div v-if="data.level == 1">
          {{data.name}}
        </div>
        <div v-else>
          <router-link
            :to="'/products/category/list-category-product/'+data.id"
            style="color: #5e50a1"
            class="text-decoration-none"
          >
            {{ data.name }}
          </router-link>
        </div>
      </template>

      <template v-slot:product_count="{data}">
        {{data.product_count}} Products
      </template>

      <template v-slot:actions="{ value, index }">
        <div>
          <router-link
            :to="'/products/' + value.url"
            class="btn border-0"
            :class="value.edit == 'disable' ? 'disabled' : ''"
          >
            <img src="@/assets/ic_edit.svg" alt="edit"/>
          </router-link>
          <button v-if="value.delete !== 'disable'" class="btn" data-bs-toggle="modal" data-bs-target="#categoryModal"
            @click="setIdCategory(value.id)">
            <font-awesome-icon icon="fa-solid fa-ban" class="text-danger" />
          </button>
          <button v-else class="btn disable">
            <PopOver
              :position="['left', index === payload?.value?.length - 1 ? 'top' : '']"
              :popoverStyle="{
                backgroundColor:'#FFE9B9',
                textAlign:'left',
                fontWeight:'300',
                border: '2px solid #FFB003'
               }"
              >
              <font-awesome-icon
                icon="fa-solid fa-ban"
                class="text-danger opacity-50"
                />
              <template v-slot:text>
                <div class="d-flex" :style="{gap:'8px'}">
                  <img :style="{width:'10px', height:'10px', marginTop:'2px'}" src="@/assets/ic_info_yellow.png" alt="icon-info"/>
                  <span>{{infoDelete}}</span>
                </div>
              </template>
            </PopOver>
          </button>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import PopOver from "@/components/PopOver.vue";
  import TableBasic from "@/components/TableBasic.vue";
  import ModalConfirm from "@/components/ModalConfirm.vue";

  export default {
    components: {
      PopOver,
      TableBasic,
      ModalConfirm
    },
    data() {
      return {
        id: "",
        payload: {
          header: [{
              key: "name",
              label: "NAME",
              sort: false,
            },
            {
              key: "parent_name",
              label: "NAME",
              sort: false
            },
            {
              key: "level_label",
              label: "LEVEL",
              sort: true,
              sort_key: 'level'
            },
            {
              key: "product_count",
              label: "COUNT",
              sort: true,
              sort_key: 'product_count'
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-center",
            },
          ],
          value: [],
          checkbox: false,
          filter: false,
          search: true,
          searchInput: "",
          button_name: "Add Category",
          button_link: "/products/category-product/add-category",
          icon_button: "add",
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100],
          startDate: "",
          endDate: "",
          searchPlaceholder: 'Search by category, sub-category or ID'
        },
        showMessage: false,
        infoDelete: "To delete this category you should transfer all products within this category to other category",
      };
    },
    methods: {
      changeParameter(value) {
        this.payload.perPage = value.per_page
        this.payload.currentPage = value.current_page
        this.searchInput = value.search
        this.payload.sort_by = value.sort_by
        this.payload.sort_type = value.sort_type
        this.getData()
      },
      async getData() {
        try {
          let payload = {
            page: this.payload.currentPage,
            size: this.payload.perPage,
            sort_by: this.payload.sort_by,
            sort_type: this.payload.sort_type,
          }

          if (this.searchInput != "") {
            payload.keyword = this.searchInput
          }

          const response = await this.$store.dispatch("product/getAllCategoryProduct", payload)
          let groupdata = this.$store.getters['product/categoryProductItems']
          console.log(groupdata)
          this.payload.value = groupdata
          this.payload.totalRows = response.count
        } catch (error) {
          this.$swal({
            title: error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
      setIdCategory(value) {
        this.id = value
      },
      async deleteCategory(value) {
        console.log("VALUE : ", value)
        try {
          await this.$store.dispatch("product/deleteCategoryProduct", value)
          const successProcess = this.$store.state.product.successInput
          if (successProcess) {
            this.showMessage = true
            setTimeout(() => {
              this.showMessage = false
              this.getData()
            }, 1500);
          }
        } catch (error) {
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      }
    },
    mounted() {
      this.getData()
    },
  };
</script>

<style scoped lang="scss">

  .btn {
    &.disable{
      cursor: default;
      border: none;
    }
  }

</style>
